import React, { useEffect, useState } from 'react';
import { FieldGroup, TextInput } from 'library/ui';
import { client, consoleLogInDev } from 'shared';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';

export default function ReferralCodeInput({
    referralCode,
    setReferralCode,
    valid,
    setValid,
}: {
    referralCode: string;
    setReferralCode: (referralCode: string) => void;
    valid: boolean;
    setValid: (valid: boolean) => void;
}) {
    const [showErrors, setShowErrors] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['referral']);
    const location = useLocation();

    useEffect(() => {
        const referral = new URLSearchParams(location.search).get('referral') ?? cookies.referral;
        setReferralCode(referral);
        validateReferralCode(referral);
    }, []);

    function validateReferralCode(code: string) {
        setShowErrors(true);
        referralCode ? setValid(false) : setValid(true);
        if (code) {
            client(`api/referral-code/validate/?code=${code}`)
                .then((response: { id: number }) => {
                    if (response.id !== null) {
                        setValid(true);
                        setCookie('referral', code, { path: '/' });
                    } else {
                        setValid(false);
                        removeCookie('referral');
                    }
                })
                .catch((error) => {
                    consoleLogInDev(error);
                    setValid(true);
                });
        }
    }

    return (
        <FieldGroup label="Referral Code">
            <TextInput
                value={referralCode ?? ''}
                onChange={(value) => setReferralCode(value.toUpperCase())}
                placeholder="Referral Code (Optional)"
                error={showErrors && !valid ? 'Invalid referral code' : undefined}
                fullWidth
            />
        </FieldGroup>
    );
}
